/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StatsAgreement
 */
export interface StatsAgreement {
    /**
     * 
     */
    compared: number;
    /**
     * 
     */
    agreed: number;
}

/**
 * Check if a given object implements the StatsAgreement interface.
 */
export function instanceOfStatsAgreement(value: object): value is StatsAgreement {
    if (!('compared' in value) || value['compared'] === undefined) return false;
    if (!('agreed' in value) || value['agreed'] === undefined) return false;
    return true;
}

export function StatsAgreementFromJSON(json: any): StatsAgreement {
    return StatsAgreementFromJSONTyped(json, false);
}

export function StatsAgreementFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatsAgreement {
    if (json == null) {
        return json;
    }
    return {
        
        'compared': json['compared'],
        'agreed': json['agreed'],
    };
}

export function StatsAgreementToJSON(json: any): StatsAgreement {
    return StatsAgreementToJSONTyped(json, false);
}

export function StatsAgreementToJSONTyped(value?: StatsAgreement | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'compared': value['compared'],
        'agreed': value['agreed'],
    };
}

